import 'jquery-ui';
import 'jquery-ui-touch-punch';

export default function FragmentTable($DOM, classes) {
	const $container = $('.fragment-table');

	if(!$container.length) {
		return false;
	}

	$('.list-products-main, .list-products > .list__body').scroll(function(event) {
		const $this = $(this);

		$this.parents('.fragment-table').find('.fragment__scrollbar').slider('option', 'value', $this.scrollLeft());

		scrollActive();
	});

	$DOM.win.load(function() {
		initSlider();
	});

	$DOM.win.on('load resize orientationchange', function() {
		setMinHeight();
		showScrollbar();
		scrollActive();
	});

	function scrollActive() {
		$container.each(function() {
			const $this     = $(this);
			const $item     = $this.find('.fragment__head li');
			const _allItems = $item.length;
			const _min      = 0;
			const _max      = $this.find('.fragment__scrollbar').slider('option', 'max');
			const _value    = $this.find('.fragment__scrollbar').slider('option', 'value');
			const _col      = parseInt( _max / _allItems, 10);

			$item.each(function(i) {
				const _progress = parseInt(_col * i, 10);

				$(this).toggleClass(classes.Active, (_progress <= _value));
			});
		});
	}

	function initSlider() {
		$container.find('.fragment__scrollbar').each(function(){
			const $this = $(this);

			$this.slider({
				min: 0,
				max: 10,
				step: 0.1,
				slide: function(event, ui) {
					const _scrollX = parseInt(ui.value, 10);

					if($this.parent().next().find('.list-products').length) {
						$this.parent().next().find('.list-products > .list__body').scrollLeft( _scrollX );
					}

					if($this.parent().next().find('.list-products-main').length) {
						$this.parent().next().find('.list-products-main').scrollLeft( _scrollX );	
					}
				}
			});
		});
	}

	function showScrollbar() {
		$container.each(function() {
			const $this  = $(this);
			const _width = parseInt($this.width(), 10);

			let _allWidth = 0;
			let _maxWidth = 0;

			if($this.find('.list-products .list__body-holder').length) {
				$this.find('.list-products .list__body-holder').each(function(){
					_allWidth += parseInt($(this).innerWidth(), 10);
				});

				if($this.find('.list-products--secondary').length) {
					_allWidth += parseInt($this.find('.list-products--secondary > .list__body').css('padding-left'), 10);
				}
			}

			if($this.find('.list-products-main').length) {
				$this.find('.list-products-main .list__wrap').removeAttr('style');

				$this.find('.list-products-main').find('.list__body > ul > li').each(function(){
					_maxWidth = 0;

					$(this).find('.list__holder > *').each(function() {
						_maxWidth += parseInt($(this).innerWidth(), 10);
					});

					if(_maxWidth > _allWidth) {
						_allWidth = _maxWidth;
					}
				});

				$this.find('.list-products-main .list__wrap').css('min-width', _allWidth);
			}

			if((_allWidth - 2) > _width) {
				$this.addClass(classes.ShowScrollbar);

				const _scrollX = _allWidth - _width;

				$this.find('.fragment__scrollbar').slider('option', 'max', _scrollX);
			} else {
				$this.removeClass(classes.ShowScrollbar);
			}
		});
	}

	function setMinHeight() {
		$container.find('.list__body-holder > ul > li').removeAttr('style');

		$container.each(function() {
			const $table      = $(this);
			const $title      = $table.find('.list__body-holder:first-child .list__title');
			const _allColumns = $table.find('.list__body-holder').length;

			let _minHeight = 0;

			$title.each(function(i) {
				const $this = $(this);
				const _row  = 2 + i;
				
				_minHeight = $this.innerHeight();

				for(let _col=1; _col<=_allColumns; _col++) {
					$table.find('.list__body-holder:nth-child( ' + _col + ') > ul > li:nth-child(' + _row + ')').each(function(j) {
						_minHeight = (_minHeight < $(this).innerHeight()) ? $(this).innerHeight() : _minHeight;
					});
				}

				$table.find('.list__body-holder > ul > li:nth-child(' + _row + ')').css('min-height', _minHeight);
			});
		});
	}
}